module.exports = __webpack_public_path__ + "static/media/magnifying-glass_dollar.9cd2b64c.png";